import React from 'react'
import style from "./AccusationCase.module.css";

const Evidence_owner = ({index, key_name, handleInput, data, tab, consult, showFiles, getShowFiles,setSubmitStatus,onChangeInput}) => {
    return (

        <div className={style.add_txt}>
            <div className={style.item_input_text}>
                <p className={style.tit}>증거(자료명)</p>
                <input type="text" name={`${key_name}_date`} data-index={index} placeholder='' value={data?.date} onChange={handleInput}/>
            </div>

            <div className={style.item_input_text}>
                <p className={style.tit}>{key_name==="documentary" ? "작성자" : key_name==="exhibit" ? "소유자" : ""}</p>
                <input type="text" name={`${key_name}_agency`} data-index={index} placeholder='' value={data?.agency} onChange={handleInput}/>
            </div>

            <div className={style.item_input_text}>
                <p className={style.tit}>제출 유무</p>
                <div className={style.item_input_textarea}>
                    <label  className={style.radio_box}>
                        <input

                            type="radio"
                            name={`${key_name}_submit_${index}`}
                            value="접수시 제출"
                            data-index={index}
                            onChange={(e)=>handleInput(e)}
                            checked={data?.content==="접수시 제출"}
                        />
                        접수시 제출
                    </label>
                    <label  className={style.radio_box}>
                        <input

                            type="radio"
                            name={`${key_name}_submit_${index}`}
                            value="수사 중 제출"
                            data-index={index}
                            onChange={(e)=>handleInput(e)}
                            checked={data?.content==="수사 중 제출"}
                        />
                        수사 중 제출
                    </label>


                </div>
            </div>

            <div className={style.item_input_text}>
                <p className={style.tit}>내용(사건 관련성, 취득 경위)</p>
                <input type="text" name={`${key_name}_evidence`} data-index={index} placeholder='' value={data?.evidence} onChange={handleInput}/>
            </div>
            ※ 증거란에 각 증거물을 개별적으로 기재하고, 소유자란에는 고소장 제출시 누가 소유하고 있는지, 제출 유무란에는 고소장 접수시 제출하는지 또는 수사 중 제출할 예정인지 표시하시기 바랍니다.
        </div>

    )
}

export default Evidence_owner
